import AlzataSortIndicator from './components/table/AlzataSortIndicator';
import AlzataTableColumnHeader from './components/table/AlzataTableColumnHeader';

import AlzataAclEditor from './components/AlzataAclEditor';
import AlzataAppHeader from './components/AlzataAppHeader';
import AlzataButton from './components/AlzataButton';
import AlzataDatePicker from './components/AlzataDatePicker';
import AlzataDialog from './components/AlzataDialog';
import AlzataDropdown from './components/AlzataDropdown';
import AlzataFormComponent from './components/AlzataFormComponent';
import AlzataIcon from './components/AlzataIcon';
import AlzataOdataTable from './components/AlzataOdataTable';
import AlzataRequiredIndicator from './components/AlzataRequiredIndicator';
import AlzataPaginator from './components/AlzataPaginator';
import AlzataSideMenu from './components/AlzataSideMenu';
import AlzataSplash from './components/AlzataSplash';
import AlzataSplashImage from './components/AlzataSplashImage';
import AlzataTab from './components/AlzataTab';
import AlzataTabs from './components/AlzataTabs';
import AlzataTextInput from './components/AlzataTextInput';

import AlzataEditRouteDialog from './dialogs/AlzataEditRouteDialog';
import AlzataEditUserDialog from './dialogs/AlzataEditUserDialog';

import AlzataAdminLayout from './layouts/AlzataAdminLayout';
import AlzataModalLayout from './layouts/AlzataModalLayout';

export default {
    install: (app) => {
        app.component('alzata-sort-indicator', AlzataSortIndicator);
        app.component('alzata-table-column-header', AlzataTableColumnHeader);
        
        app.component('alzata-acl-editor', AlzataAclEditor);
        app.component('alzata-app-header', AlzataAppHeader);
        app.component('alzata-button', AlzataButton);
        app.component('alzata-date-picker', AlzataDatePicker);
        app.component('alzata-dialog', AlzataDialog);
        app.component('alzata-dropdown', AlzataDropdown);
        app.component('alzata-form-component', AlzataFormComponent);
        app.component('alzata-icon', AlzataIcon);
        app.component('alzata-odata-table', AlzataOdataTable);
        app.component('alzata-required-indicator', AlzataRequiredIndicator);
        app.component('alzata-paginator', AlzataPaginator);
        app.component('alzata-side-menu', AlzataSideMenu);
        app.component('alzata-splash', AlzataSplash);
        app.component('alzata-splash-image', AlzataSplashImage);
        app.component('alzata-tab', AlzataTab);
        app.component('alzata-tabs', AlzataTabs);
        app.component('alzata-text-input', AlzataTextInput);

        app.component('alzata-edit-route-dialog', AlzataEditRouteDialog);
        app.component('alzata-edit-user-dialog', AlzataEditUserDialog);

        app.component('alzata-admin-layout', AlzataAdminLayout);
        app.component('alzata-modal-layout', AlzataModalLayout);

        app.config.globalProperties.appSettings = {
            title: 'Alzata',
        };
    },
};